var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProperty1Nh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5063 4.19719L8.39174 2L12.4507 9.77468L16.5096 2.05634L12.5063 4.19719ZM15.6208 4.81669L20.8474 2.67583V6.56317L17.8449 7.91529C19.6241 9.38009 20.7918 11.5773 20.7918 13.9998C20.7918 18.3942 17.0108 21.9999 12.3959 21.9999C7.72533 21.9999 4 18.4505 4 13.9998C4 11.5209 5.16764 9.32375 7.0581 7.80261L4.0556 6.4505V2.56316L9.22658 4.76035L10.0606 6.28148L11.9511 9.88713C9.8382 10.1688 8.22574 11.9153 8.22574 13.9998C8.22574 16.2534 10.1718 18.1125 12.5627 18.1125C14.9536 18.1125 16.8996 16.3097 16.8996 13.9998C16.8996 11.859 15.176 10.0561 12.9519 9.88713L14.7312 6.39416H14.7868L15.6208 4.81669Z",
    fill: "#FFDC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProperty1Nh);
export default __webpack_public_path__ + "static/media/Property 1=nh.759cd9745c7a34ba5955ac74254c2226.svg";
export { ForwardRef as ReactComponent };